import { useContext, useState } from 'react';
import IpaffsModaltable from './IpaffsModalTable';

import { Spinner } from 'react-bootstrap';
import { downloadCABIEFile } from '../../api/newLoad';
import DownloadIcon from '../../images/download.svg';
import DataTable from '../DataTable';
import { PreferentialTooltip } from '../Newload/ProductInfo/Tooltips';
import Tooltip from '../Tooltip/Tooltip';

import { IpaffsContext } from './IpaffsModal';
import { StoreContext } from '../Store';

const IpaffsModalConsolidatedView = () => {
  const [persist, setPersist] = useState({});
  const [isDownloadingFile, setIsDownloadingFile] = useState(false);
  const { handleSetItemsConsolidatedValue, consolidatedData } = useContext(IpaffsContext);
  const { loadId, newLoadItemsModified, portalRef } = useContext(StoreContext);

  const onDownloadClick = async (origin, hsCodes) => {
    setIsDownloadingFile(true);
    await downloadCABIEFile({ loadId: loadId[0], fileName: `IPAFFS-${portalRef[0]}-${origin}`, origin, hsCodes });
    setIsDownloadingFile(false);
  };

  const DownloadIconImage = (
    <div>
      <img src={DownloadIcon} alt="Download" />
    </div>
  );

  return (
    <IpaffsModaltable data={consolidatedData?.data ?? []} persist={persist} setPersist={setPersist}>
      <DataTable.Column
        colKey="confirmedCategory"
        key="confirmedCategory"
        header="IPAFFS Risk Category"
        tooltip={
          <PreferentialTooltip>
            <p>This is the category selected in the detailed section.</p>
          </PreferentialTooltip>
        }
        maxWidth="12ch"
      >
        {(item) => {
          return <>{item?.riskCategory ?? ''}</>;
        }}
      </DataTable.Column>
      <DataTable.Column colKey={'origin'} key={'origin'} header="Origin" />;
      <DataTable.Column colKey="ipaffsCodes" key="ipaffsCodes" header="IPAFFS HS Codes">
        {(row) => {
          return <>{row?.ipaffsHSCodes?.join(', ') ?? ''}</>;
        }}
      </DataTable.Column>
      <DataTable.Column
        colKey="consolidatedIpaffs"
        header="CHED Ref"
        style={{ height: '1px', padding: 0 }}
        className="m-2 edit-cell system-reference"
        tooltip={
          <PreferentialTooltip>
            <p>
              Enter IPAFFS reference to populate the Health Cert column for the corresponding HS Code and Risk Category.
            </p>
          </PreferentialTooltip>
        }
        beforeChange={(value, item) => {
          handleSetItemsConsolidatedValue(item, value);
          return value;
        }}
        editable
      />
      <DataTable.Column
        colKey="ipaffsFile"
        header="IPAFFS File"
        style={{ height: '1px', padding: 0 }}
        tooltip={
          <PreferentialTooltip>
            <p>Select the download icon to download Low risk IPAFFS data</p>
          </PreferentialTooltip>
        }
        maxWidth="4ch"
      >
        {(row) => {
          if (row.riskCategory !== 'Low') {
            return null;
          }

          if (!loadId[0] || newLoadItemsModified[0]) {
            return (
              <div className="d-flex align-items-center justify-content-center h-100 px-3">
                <Tooltip icon={<div>{DownloadIconImage}</div>}>
                  <p className="text-center">Please Save as Draft in order to download the IPAFFS file.</p>
                </Tooltip>
              </div>
            );
          }

          return (
            <div className="d-flex align-items-center h-100 px-3">
              <button
                className="external-table-link"
                onClick={() => onDownloadClick(row.origin, row.hsCodes)}
                disabled={isDownloadingFile}
              >
                {isDownloadingFile ? <Spinner animation="border" size="sm" /> : DownloadIconImage}
              </button>
            </div>
          );
        }}
      </DataTable.Column>
    </IpaffsModaltable>
  );
};

export default IpaffsModalConsolidatedView;
